import { LoaderFunction, MetaFunction } from '@remix-run/node'
import { defer, useLoaderData } from '@remix-run/react'
import AreaServices from '~/lib/services/AreaServices'
import { getDeviceInfo } from '~/lib/hooks/useViewportListener'
import MobileLayout from '~/components/blocks/SpaceTypePage/MobileLayout'
import DesktopLayout from '~/components/blocks/SpaceTypePage/DesktopLayout'
import { getCountryName } from '~/lib/helpers/constants'
import BlogsService from '~/lib/services/BlogsService'
import { officeTypeMeta } from '~/utils/Meta/officeTypeMeta'
import { getConfig, regionConfigs } from 'custom-config/region.configs'
import { DEFAULT_REGION } from '~/lib/constants/generalConstants'
import { getRegionUrlPrefix } from '~/lib/helpers/slugHelper'
import { buildPropertyNavCityUrl } from '~/components/blocks/Geosearch/locationGeosearch'

export const meta: MetaFunction = ({ data, location }) => {
  if (!data || !location) return [];
  return officeTypeMeta({ data, path: location.pathname || '/' });
};



export const loader: LoaderFunction = async ({ params, request }) => {
  const { isMobile } = getDeviceInfo(request);
  const countryCode = params.country || "us";
  const countryName = getCountryName(countryCode);
  const regionData = getConfig((countryCode || DEFAULT_REGION) as keyof typeof regionConfigs) ?? undefined;
  const searchUrl = buildPropertyNavCityUrl(
    getRegionUrlPrefix(regionData.country),
    regionData.state ?? "",
    regionData.city ?? "",
    {
      latitude: regionData.lat,
      longitude: regionData.lng,
      zoom: 12,
    },
  );
  const faqs = AreaServices.getWorkspaceFAQs(getCountryName(params.country || 'us'))
  const blogs = BlogsService.getBlogsByCategory('', getCountryName(params.country || 'us'))

  // const data = await Promise.all($Promises)
  // const [faqs, blogs] = data



  return defer({ faqs, blogs, areaSummary: null, isMobile, country: params.country || 'us', countryName, regionData, searchUrl })
}

const Index = () => {
  const data: any = useLoaderData()
  const { faqs, blogs, areaSummary, isMobile, country, countryName, regionData, searchUrl } = data



  return (
    isMobile ?
      <MobileLayout areaSummary={areaSummary} faqs={faqs} blogs={blogs} country={country} countryName={countryName} searchUrl={searchUrl} regionData={regionData} />
      : <DesktopLayout areaSummary={areaSummary} faqs={faqs} blogs={blogs} country={country} countryName={countryName} searchUrl={searchUrl} regionData={regionData} />
  )
}

export default Index